import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './api/client';

/**
 * Global React Query client. Tuned for a multi-tenant admin dashboard:
 *   - Server data is rarely stale on the second-scale (30s).
 *   - We do not refetch on window focus — admins routinely tab away.
 *   - 401/404 errors must not retry; they're terminal.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.status === 401 || error.status === 404 || error.status === 403) {
            return false;
          }
          if (error.status === 422) {
            return false;
          }
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
